/* eslint-disable */
// import { readdirSync } from 'fs'
import { getJWT, unsetCookie, getCookie, check } from "@lib/util";

let commonPrefix =
  `${window.API_PREFIX}${window.ENV_BRANCH}` ||
  `/python-class-mobile-classroom/backend${window.ENV_BRANCH}`;
// let commonPrefix = window.API_PREFIX || ""; // 本地开发
const application = window.APP_POSITION ? `${window.APP_POSITION}` : "pyclass";

const common = {
  wechatConfig: {
    method: "post",
    url: `https://${window.location.hostname ||
      "prod.pandateacher.com"}/python-class-fos/api-enrollment-go${
      window.ENV_BRANCH
    }/wxconfig/${application}`
  },
  commonShare: {
    url: `https://${window.location.hostname ||
      "prod.pandateacher.com"}/python-class-mobile-classroom/backend${
      window.ENV_BRANCH
    }/interact/${application}/share`
  }
};

let host = "https://prod.pandateacher.com";
const mock_host =
  "https://result.eolinker.com/gISlzyz006bc57a0f785da1ee862be1e49053a90c8e637c?uri=";

const apiss = [common];

if (process.env.NODE_ENV === "development") {
  host = `http://${window.location.hostname}:3037/pandaclass`;
  // common.wechatConfig.path = '/wechat-config'
}

if (process.env.NODE_ENV === "debug") {
  host = process.env.HOST || host;
}

if (process.env.NODE_ENV !== "production") {
  const qs = window.location.search;
  const reg = /(\w*)=([^/|&]*)/g;
  const query = {};
  let match = null;

  while ((match = reg.exec(qs))) {
    query[match[1]] = match[2];
  }

  if (query.host) {
    if (query.host.match(/^http/)) {
      host = decodeURIComponent(query.host);
    } else {
      host = `http://${decodeURIComponent(query.host)}`;
    }
  }
  if (query.mock) {
    window.API_PREFIX = commonPrefix = "";
    window.HOST = mock_host;
    // delToken();
  }
}

// const modules = readdirSync(`${__dirname}/modules`)
var c = check();
// .*会被参数替换为前端构建时候的环境变量
try {
  let context = require.context(`./modules`, true, /(.*)\/apis\.js$/);
  context.keys().forEach(key => {
    // console.log(key)
    if (process.env.NODE_ENV != "production") {
      console.log(`apis：${key}`);
    }
    try {
      let { default: apis, prefix } = context(key);
      if (typeof prefix !== "string") {
        prefix = commonPrefix;
      }
      Object.keys(apis).forEach(a => {
        const cur = apis[a];
        if (cur.path && cur.path.length > 0) {
          cur.path = `${prefix}/${cur.path.replace(/^\//g, "")}`;
        }
      });
      apiss.push(apis);
      c(apis);
    } catch (error) {
      console.error(error);
      console.error(`我怀疑你有空的api或者router，路径为${key}`);
    }
  });
} catch (err) {
  console.warn(err.message);
}

let cookieHost = getCookie("host");
if (!/^http/.exec(cookieHost)) {
  cookieHost = undefined;
}

host = window.HOST || cookieHost || host;

const config = Object.assign(
  {
    host
  },
  ...apiss
);

export default config;



// WEBPACK FOOTER //
// ./src/apis.js